// src/components/Research.jsx
import React from "react";
import "./Research.css";

const research = [
  {
    title: "Gestalt Psychotherapy in Nepalese Context, Ganesh Amgain, Nepalese Psychology: Volume One (pp.231-238).",
    place: " ",
  },
  {
    title: "Psychosocial Support during COVID-19 Pandemic, Ganesh Amgain & Rishika Pokharel, Journal of Karnali Academy of Health Sciences, 2021, 4(1).",
    place: " ",
  },
  {
    title: "Cool Parent Syndrome; Redefining Cool, Ganesh Amgain Europasian Journal of Medical Sciences, 2020, 1(1), 1-5.",
    place: " ",
  },
  {
    title: "Incidence and factors associated with post-spinal headache among patients receiving spinal anesthesia at Bharatpur Hospital, Chitwan. Nepal, Mina Kumari Bhusal, Laxmi Rajbanshi, Kapil Amgain, Ganesh Amgain, European journal of pharmaceutical and medical research. 2017,4(5), 319-324.",
    place: " ",
  },
  {
    title: "Burden of various cancers with respect to bio-social features of patient attaining in a tertiary level health care facility of Jiangsu province of China, Dr. Laxmi Panthy, Prof. Dr. Zhu Zhengqiu, Dr. Kapil Amgain, Ashok Pandey, Ganesh Amgain, Dr. Dillee Prasad Paudel. European journal of pharmaceutical and medical research. 2016, 3(7), 582-587.",
    place: " ",
  },
  {
    title: "Sex differences on adjustment and self-esteem of adolescents of convicted and non-convicted parents, Ganesh Amgain, Khem Raj Bhatta, Kapil Amgain & Raja Ram Dhungana. European journal of pharmaceutical and medical research. 2016, 3(7), 483-488.",
    place: " ",
  },
  {
    title: "A Comparative study on adjustment and self-esteem of adolescents of convicted parents and non- convicted parents: a cross-sectional study in Kathmandu, Nepal, Ganesh Amgain, Khem Raj Bhatta, Kapil Amgain & Raja Ram Dhungana, International Journal of Current Research and Academic Review. Volume 3 Number 5 (May-2015) pp. 346-353.",
    place: " ",
  },
  {
    title: "Awareness and attitude of pulmonary tuberculosis patients towards tuberculosis: A cross sectional study from chitwan Nepal, Kapil Amgain, Mahendra Maharjan, Dillee pd Paudel, Ganesh Amgain, Mukesh Dhital, Damaru Pd Paneru, International journal of Health sciences, oct-dec; 2014, vol.3, issue 4, pp 216-220.",
    place: " ",
  },
  {
    title: "Gender Difference on case detection of pulmonary tuberculosis among the suspected cases attending in Jutpani primary health centre of Chitwan Nepal, Kapil Amgain, DP Paudel, Mukesh Dhital, Ganesh Amgain, SAARC Journal of Tuberculosis, Lung Diseases & HIV/AIDS 2013; X (1)",
    place: " ",
  },
];

const Research = () => {
  return (
    <section id="research" className="research-section">
      <h2>Research & Publications</h2>
      <div className="research-grid">
        {research.map((q, index) => (
          <div key={index} className="research-item">
            <p>{q.title}</p>
            <p>{q.place}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Research;
